<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-text-field
      :label="model.Caption"
      prepend-icon="mdi mdi-calendar"
      :disabled="isDisabled"
      :class="evaluateClasses(classes)"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
    ></v-text-field>
  </dr-wrapper>
  <dr-date-edit-component
    v-else-if="isVisible"
    :class="evaluateClasses(classes)"
    v-bind="$props"
    :regular="isRegular"
    :solo="isSolo"
    :outlined="isOutlined"
    :filled="isFilled"
    @callDataSourceAction="$emit('callDataSourceAction', $event)"
  ></dr-date-edit-component>
</template>

<script>
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import baseMixin from '../../mixins/base-mixin'
import drDateEditComponent from './dr-date-edit-component'

export default {
  mixins: [inputMixin, baseMixin, widgetsWrapperMixin],
  components: {
    drDateEditComponent
  }
}
</script>

<style>
</style>